document.addEventListener("DOMContentLoaded", function() {
  const bar = document.getElementById("AnnouncementBar");
  const offset = 0; // or header height if needed

  window.addEventListener("scroll", function() {
    if (window.scrollY > 0) {
      bar.style.position = "fixed";
      bar.style.top = offset + "px";
      bar.style.left = "0";
      bar.style.right = "0";
      bar.style.zIndex = "9999";
    } else {
      bar.style.position = "relative";
      bar.style.top = "0";
    }
  });
});
